import React, {useEffect} from "react";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import {SeoHead} from "./SeoHead";
import {useLocation} from "react-router";
import {useSmoothScroll} from "./useSmoothScroll";
import {HeroSection} from "../landing/HeroSection";
import {AboutSection} from "../landing/AboutSection";
import {MeditationSection} from "../landing/MeditationSection";
import {InstructorsSection} from "../landing/InstructorsSection";
import {TestimonialsSection} from "../landing/TestimonialsSection";
import {NewsSection} from "../landing/NewsSection";
import {ProfessionalsSection} from "../landing/ProfessionalsSection";

export const LandingPage = () => {
    const location = useLocation();
    const scrollToSection = useSmoothScroll();

    useEffect(() => {
        if (location.hash) {
            const id = location.hash.replace("#", "");
            const element = document.getElementById(id);
            if (element) {
                const prefersReducedMotion =
                    typeof window !== "undefined" &&
                    window.matchMedia &&
                    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

                element.scrollIntoView({
                    behavior: prefersReducedMotion ? "auto" : "smooth",
                    block: "start",
                });
            }
        }
    }, [location.hash]);

    return (
        <Box sx={{width: "100%", maxWidth: "100%", minWidth: 0, overflowX: "clip"}}>
            <SeoHead
                title="Kurs i Bekymringsmestring | Forskningsbasert mestring og meditasjon"
                description="Forskningsbasert og helhetlig kurs i bekymringsmestring. Bygget på metakognitiv terapi, mindfulness og emosjonsfokuserte prinsipper. Finn autoriserte kursholdere over hele landet."
                path="/"
            />

            {/* Section 1: Hero - Soft warm oat */}
            <Box
                sx={{
                    width: "100%",
                    maxWidth: "100%",
                    overflowX: "clip",
                    boxSizing: "border-box",
                    bgcolor: "#FAF8F5",
                    borderBottom: "1px solid",
                    borderColor: "rgba(40, 82, 56, 0.06)",
                }}
            >
                <Container
                    maxWidth="lg"
                    sx={{
                        px: {xs: 1.5, sm: 3, md: 4},
                        py: {xs: 1, sm: 2},
                    }}
                >
                    <HeroSection onScrollTo={scrollToSection} />
                </Container>
            </Box>

            {/* Section 2: Om kurset - Crisp clean white */}
            <Box
                sx={{
                    width: "100%",
                    maxWidth: "100%",
                    overflowX: "clip",
                    boxSizing: "border-box",
                    bgcolor: "#FFFFFF",
                    borderBottom: "1px solid",
                    borderColor: "rgba(40, 82, 56, 0.06)",
                }}
            >
                <Container
                    maxWidth="lg"
                    sx={{
                        px: {xs: 1.5, sm: 3, md: 4},
                    }}
                >
                    <AboutSection />
                </Container>
            </Box>

            {/* Section 3: Meditasjon - Calm restorative sage mist */}
            <Box
                sx={{
                    width: "100%",
                    maxWidth: "100%",
                    overflowX: "clip",
                    boxSizing: "border-box",
                    bgcolor: "#F3F7F4",
                    borderBottom: "1px solid",
                    borderColor: "rgba(40, 82, 56, 0.08)",
                }}
            >
                <Container
                    maxWidth="lg"
                    sx={{
                        px: {xs: 1.5, sm: 3, md: 4},
                    }}
                >
                    <MeditationSection />
                </Container>
            </Box>

            {/* Section 4: Erfaringer fra fagfolk - Warm comforting oat */}
            <Box
                sx={{
                    width: "100%",
                    maxWidth: "100%",
                    overflowX: "clip",
                    boxSizing: "border-box",
                    bgcolor: "#FAF8F5",
                    borderBottom: "1px solid",
                    borderColor: "rgba(40, 82, 56, 0.06)",
                }}
            >
                <Container
                    maxWidth="lg"
                    sx={{
                        px: {xs: 1.5, sm: 3, md: 4},
                    }}
                >
                    <TestimonialsSection />
                </Container>
            </Box>

            {/* Section 5: Finn kursholder - Crisp clean white */}
            <Box
                sx={{
                    width: "100%",
                    maxWidth: "100%",
                    overflowX: "clip",
                    boxSizing: "border-box",
                    bgcolor: "#FFFFFF",
                    borderBottom: "1px solid",
                    borderColor: "rgba(40, 82, 56, 0.06)",
                }}
            >
                <Container
                    maxWidth="lg"
                    sx={{
                        px: {xs: 1.5, sm: 3, md: 4},
                    }}
                >
                    <InstructorsSection />
                </Container>
            </Box>

            {/* Section 6: Aktuelt & Nyheter - Crisp clean white */}
            <Box
                sx={{
                    width: "100%",
                    maxWidth: "100%",
                    overflowX: "clip",
                    boxSizing: "border-box",
                    bgcolor: "#FFFFFF",
                    borderBottom: "1px solid",
                    borderColor: "rgba(40, 82, 56, 0.06)",
                }}
            >
                <Container
                    maxWidth="lg"
                    sx={{
                        px: {xs: 1.5, sm: 3, md: 4},
                    }}
                >
                    <NewsSection />
                </Container>
            </Box>

            {/* Section 7: For fagfolk - Serene sage linen */}
            <Box
                sx={{
                    width: "100%",
                    maxWidth: "100%",
                    overflowX: "clip",
                    boxSizing: "border-box",
                    bgcolor: "#F8F6F1",
                }}
            >
                <Container
                    maxWidth="lg"
                    sx={{
                        px: {xs: 1.5, sm: 3, md: 4},
                    }}
                >
                    <ProfessionalsSection />
                </Container>
            </Box>
        </Box>
    );
};